import { useRouter } from "next/router";
import ErrorPage from "next/error";

import { Date as PrismicDate, RichText } from "prismic-reactjs";

import { NextSeo } from "next-seo";

import { getBlog, BlogPost, getAllBlogURLs } from "lib/prismic/blog";

import SectionShell from "components/Section-Shell";
import SubscribeUpdates from "elements/Subscribe-to-Updates";
import Divider from "components/Divider";

const BlogPostComponent = ({
  preview,
  post,
}: {
  preview: boolean;
  post: BlogPost;
}) => {
  const router = useRouter();

  if (!router.isFallback && !post?.uid) {
    return <ErrorPage statusCode={404} />;
  }
  if (router.isFallback) {
    return <p>Loading...</p>;
  }
  const { data } = post;
  const imageUrl = data.cover_image?.url;

  return (
    <>
      <NextSeo
        title={`Daisho | ${data.title[0].text}`}
        description={data.excerpt[0].text}
      />
      <SectionShell
        tag={
          <>
            {imageUrl && (
              <img
                className="mb-4 h-48 w-full object-center object-contain"
                src={imageUrl}
                alt={data.title[0].text}
              />
            )}
            <small>
              {new Date(PrismicDate(data.publish_date)).toLocaleDateString()}
            </small>
          </>
        }
        heading={data.title[0].text}
        subtitle={data.excerpt[0].text}
      >
        <article
          className="prose w-full max-w-6xl"
          data-aos="zoom-y-out"
          data-aos-delay="300"
        >
          {data.content.map((c, ind) => (
            <div key={ind}>
              {c.subHeading && (
                <p className="font-bold">{RichText.asText(c.subHeading)}</p>
              )}
              {c.paragraph1 && <RichText render={c.paragraph1} />}
              {c.insight && (
                <p className="text-center italic font-bold text-xl">
                  {RichText.asText(c.insight)}
                </p>
              )}
            </div>
          ))}
        </article>
        <Divider />
        <SubscribeUpdates />
      </SectionShell>
    </>
  );
};

export default BlogPostComponent;

export async function getStaticProps({ params, preview = false, previewData }) {
  const data = await getBlog(params.slug, previewData);
  return {
    props: {
      preview,
      post: data || null,
    },
  };
}

export async function getStaticPaths() {
  const blogIds = await getAllBlogURLs();

  const paths = blogIds?.map((post) => `/blog/${post}`) || [];

  return {
    paths,
    fallback: true,
  };
}
